import { type ComponentType } from 'react';

import { Dialog } from '../dialog';

export const withLoaderDialogComponent = <T,>(Component: ComponentType<T>, props: T) => (
  <Component {...props} DialogComponent={Dialog} />
);
